import { useState, useMemo } from 'react';
import { ALL_ICONS } from '../featureFormConstants';

export function IconPicker({ value, onChange }: { value: string; onChange: (key: string) => void }) {
  const [iconSearch, setIconSearch] = useState('');
  const filtered = useMemo(() => {
    if (!iconSearch.trim()) return ALL_ICONS;
    const q = iconSearch.toLowerCase();
    return ALL_ICONS.filter(i => i.label.toLowerCase().includes(q) || i.key.toLowerCase().includes(q));
  }, [iconSearch]);

  const selected = ALL_ICONS.find(i => i.key === value);

  return (
    <div>
      {/* Selected preview + search */}
      <div className="flex items-center gap-3 mb-2">
        <div className="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg border border-gray-200 min-w-[120px]">
          {selected ? (
            <>
              <selected.Component className="w-5 h-5 text-gray-700" />
              <span className="text-xs font-medium text-gray-700">{selected.label}</span>
            </>
          ) : (
            <span className="text-xs text-gray-400">No icon selected</span>
          )}
        </div>
        <div className="relative flex-1">
          <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-xs">🔍</span>
          <input
            type="text"
            value={iconSearch}
            onChange={e => setIconSearch(e.target.value)}
            placeholder="Search icons…"
            className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
          />
        </div>
      </div>

      {/* Icon grid */}
      <div className="grid grid-cols-6 sm:grid-cols-8 gap-1.5 max-h-48 overflow-y-auto p-1 bg-gray-50 rounded-xl border border-gray-200">
        {filtered.map(icon => {
          const isSelected = value === icon.key;
          return (
            <button
              key={icon.key}
              type="button"
              onClick={() => onChange(icon.key)}
              title={icon.label}
              className={`flex flex-col items-center justify-center gap-0.5 p-2 rounded-lg border transition-all duration-150 ${
                isSelected
                  ? 'bg-emerald-100 border-emerald-400 shadow-sm'
                  : 'bg-white border-gray-200 hover:bg-gray-100 hover:border-gray-300'
              }`}
            >
              <icon.Component className={`w-5 h-5 ${isSelected ? 'text-emerald-700' : 'text-gray-600'}`} />
              <span className={`text-xs leading-tight text-center ${isSelected ? 'text-emerald-700 font-semibold' : 'text-gray-500'}`}
                style={{ fontSize: '9px' }}>
                {icon.label.split(' ')[0]}
              </span>
            </button>
          );
        })}
        {filtered.length === 0 && (
          <div className="col-span-full text-center py-4 text-xs text-gray-400">No icons found</div>
        )}
      </div>
    </div>
  );
}
